import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-cookie-notice',
    templateUrl: './cookie-notice.component.html',
    styleUrl: './cookie-notice.component.less',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CookieNoticeComponent {
  isaccordian1open = false;
  isaccordian2open = false;
  isaccordian3open = false;
  isaccordian4open = false;

}
